// extracted by mini-css-extract-plugin
export var button = "index-module--button--DVTj8";
export var buttonContainer = "index-module--buttonContainer--MqbCJ";
export var contactDetails = "index-module--contactDetails--3teLK";
export var contactInfo = "index-module--contactInfo--Ym3Nr";
export var footer = "index-module--footer--uojx8";
export var footerIntro = "index-module--footerIntro--LkODG";
export var footerMain = "index-module--footerMain--Z6Shy";
export var footerMeta = "index-module--footerMeta--2+sx9";
export var languageArrow = "index-module--languageArrow--znOoY";
export var languageDropdown = "index-module--languageDropdown--TkE1o";
export var languageMenu = "index-module--languageMenu--17bax";
export var languageSwitch = "index-module--languageSwitch--9dfJd";
export var logo = "index-module--logo--NayvD";
export var mobileFooterInfo = "index-module--mobileFooterInfo--YaIfQ";
export var mobilePolicyLinks = "index-module--mobilePolicyLinks--GQAbA";
export var pcContainer = "index-module--pcContainer--zvA6W";
export var policyLinks = "index-module--policyLinks--ua2Nv";